import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseURL } from "../common/baseURL";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { FaFolderOpen } from "react-icons/fa";
import Modal from "react-modal"; 

const FileUpload = () => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState([]);
  const [checkUploadOnce, setCheckUploadOnce] = useState(true);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileToUpdate, setFileToUpdate] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [updateProgress, setUpdateProgress] = useState(0);
  const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [subDirectories, setSubDirectories] = useState([]);
  const [folderName1, setFolderName1] = useState("");
  const location = useLocation();
  const folderName = location.state.folderName;
  const subfolderName = location.state.subfolderName;
  const processedFolderName = folderName.replace(/\s+/g, "-");
  const navigate = useNavigate();


  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setFileToUpdate(null);
    setIsModalOpen(false);
  };

 

  useEffect(() => {
    const fetchFiles = async () => {
      console.log("foldername is ", folderName);
      try {
        const url = subfolderName
          ? `${baseURL}/files/${folderName}?subfolderName=${encodeURIComponent(
              subfolderName
            )}`
          : `${baseURL}/files/${folderName}`;

        const response = await axios.get(url);
        setFiles(response.data);
      } catch (error) {
        alert("Error fetching file list.", error);
      }
    };

    fetchFiles();
  }, [folderName, subfolderName]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 568); 
    };
    handleResize(); 
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const backButtonClicked = () => {
    navigate("/");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setUploadProgress(0);

  
  
    const formData = new FormData(event.target);
    
    const file = formData.get("file");

    // Check if a file is selected
    // if (!file) {
    //   setMessage("Please select a file.");
    //   return;
    // }
  
    // Restrict to .mp4 files only
    if (file.type !== "video/mp4") {
      setMessage("Only .mp4 files are allowed.");
      return;
    }
    formData.append("folderName", folderName);
    if (subfolderName) {
      formData.append("subfolderName", subfolderName);
    }
  
    try {
      const response = await axios.post(`${baseURL}/upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setIsButtonDisabled(true);
            setUploadProgress(percent);
          }
        },
      });
  
      setMessage("File uploaded successfully!");
      setIsButtonDisabled(false);
      
   
      const newFileName = formData.get("file").name;
      setFiles((prevFiles) => (Array.isArray(prevFiles) ? [...prevFiles, newFileName] : [newFileName]));

          setTimeout(() => {
        window.location.reload();
      }, 1000);
  
    } catch (error) {
      setMessage("Error uploading file.");
    }
  };
  
 

  const handleFileInputClick = () => {
    setCheckUploadOnce(true);
    setMessage("");
    if (isButtonDisabled) {
      setIsButtonDisabled(false);
    }
  };

  const handleDelete = async (filename) => {
    if (window.confirm("Are you sure you want to delete this file?")) {
      try {
        const url = subfolderName
          ? `${baseURL}/files/${folderName}/${filename}?subfolderName=${subfolderName}`
          : `${baseURL}/files/${folderName}/${filename}`;

        await axios.delete(url);

        const fileListResponse = await axios.get(
          `${baseURL}/files/${folderName}${
            subfolderName ? `?subfolderName=${subfolderName}` : ""
          }`
        );

 
        setFiles(fileListResponse.data);

        alert("File deleted successfully.");
      } catch (error) {
        console.error("Error deleting file:", error);
        alert("Error deleting file.");
      }
    }
  };

  const handleUpdateClick = (filename) => {
    setFileToUpdate(filename);
    setSelectedFile(null);
    openModal()
  };

  const handleUpdateFile = async () => {
    if (selectedFile && fileToUpdate && folderName) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      if (subfolderName) {
        formData.append("subfolderName", subfolderName);
      }
      setIsUpdateButtonDisabled(true);
      setUpdateProgress(0);

      try {
        await axios.put(
          `${baseURL}/files/${folderName}/${fileToUpdate}`,

          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                setUpdateProgress(percent);
              }
            },
          }
        );

        setUpdateProgress(100);

        // Delay alert to allow the UI to update the progress bar
        setTimeout(() => {
          alert("File updated successfully.");
          window.location.reload();
        }, 200);

        const fileListResponse = await axios.get(
          `${baseURL}/files/${folderName}`
        );
        setFiles(fileListResponse.data);
      } catch (error) {
        console.error("Error updating file:", error);
        alert("Error updating file.");
      } finally {
        setFileToUpdate(null);
        setSelectedFile(null);
        setIsUpdateButtonDisabled(false);
        // setUpdateProgress(0);
      }
    } else {
      alert("Please select a file first");
    }
  };

  return (
    <div style={styles.container}>
      {isMobile ? (
        <>
          <div style={styles.foldernM}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
                width: "100%",
              }}
            >
            
              <h3
                style={{
                  textAlign: "-webkit-left",
                  placeSelf: "normal",
                  fontFamily: "Montserrat",
               
                }}
              >
                {subfolderName
  ? `${folderName === "DiscussionLab" ? "DiscussionTheatre" : folderName}/${subfolderName.replace(/-/g, " ")}`
  : folderName === "DiscussionLab" ? "DiscussionTheatre" : folderName}

                <span>
                  {" "}
                  <FaFolderOpen style={{ verticalAlign: "middle" }} />
                </span>
              </h3>
            </div>
            <form
              id="uploadForm"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              style={styles.formM}
            >
              <input
                type="file"
                name="file"
                accept=".mp4"
                required
                id="fileInput"
                onClick={handleFileInputClick}
                style={styles.fileInput}
              />
              <button
                type="submit"
                disabled={isButtonDisabled}
                style={{
                  ...styles.button,
                  background: isButtonDisabled
                    ? "black"
                    : "linear-gradient(to right, #191c51, #2092d0)",
                }}
              >
                Upload
              </button>
              <div
                id="message"
                style={{
                  ...styles.message,
                  color: isButtonDisabled ? "#191c51" : "black",
                }}
              >
                {message}
              </div>
            </form>

            {uploadProgress > 0 && uploadProgress < 100 && (
              <div style={styles.progressBarContainer}>
                <div
                  style={{
                    ...styles.progressBar,
                    width: `${uploadProgress}%`,
                  }}
                />
              </div>
            )}

            {files.length > 0 ? (
              <div style={{ ...styles.fileList, width: "100%" }}>
                {files.map((file) => (
                  <div key={file} style={styles.fileItem}>
                    <div style={{ textAlign: "-webkit-left" ,width:'50%'}}>
                      <img
                        // src={`${baseURL}/thumbnails/${folderName}/${file}`}
                        src={
                          subfolderName
                            ? `${baseURL}/thumbnails/${processedFolderName}/${subfolderName}/${file}.png`
                            : `${baseURL}/thumbnails/${folderName}/${file}`
                        }
                        alt={`Thumbnail`}
                        width="100px"
                        height="10%"
                        style={styles.image}
                      />
                      <span style={{ fontSize: 8 }}>{file}</span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 0,
                        alignSelf: "start",
                      }}
                    >
                      <button
                        onClick={() => handleDelete(file)}
                        style={styles.actionButton1}
                      >
                        Delete
                      </button>
                      <button
                        onClick={() => handleUpdateClick(file)}
                        style={styles.actionButton}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <h4>There are no Videos in this folder!</h4>
            )}

              <Modal
                   isOpen={isModalOpen}
                   onRequestClose={closeModal}
                   style={modalStyles}
                 >
              {/* <div style={styles.modalM}> */}
                <h3 style={{ fontFamily: "Montserrat" }}>
                  Select a new file to update
                </h3>
                <input
                  name="file"
                  accept=".mp4"
                  required
                  type="file"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
                <button
                  onClick={handleUpdateFile}
                  style={styles.button}
                  disabled={isUpdateButtonDisabled}
                >
                  Update File
                </button>
                <button
                  onClick={closeModal}
                  style={styles.button1}
                  disabled={isUpdateButtonDisabled}
                >
                  Close
                </button>

                {updateProgress > 0 && updateProgress < 100 && (
                  <div style={styles.progressBarContainer1}>
                    <div
                      style={{
                        ...styles.progressBar,
                        width: `${updateProgress}%`,
                      }}
                    />
                  </div>
                )}
              {/* </div> */}
              </Modal>
            
          </div>
        </>
      ) : (
        <>
          <div style={styles.foldern}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                width: "60%",
                backgroundColor: "transparent",
                marginRight: "auto",
                alignItems: "center",
              }}
            >
           
              <h3
                style={{
                  textAlign: "-webkit-left",
                  placeSelf: "normal",
                  fontFamily: "Montserrat",
                  // display:'flex',
                  // alignItems:'center'
                }}
              >
                            {subfolderName
  ? `${folderName === "DiscussionLab" ? "DiscussionTheatre" : folderName}/${subfolderName.replace(/-/g, " ")}`
  : folderName === "DiscussionLab" ? "DiscussionTheatre" : folderName}

                <span>
                  {" "}
                  <FaFolderOpen
                    style={{ verticalAlign: "middle" }}
                  ></FaFolderOpen>
                </span>
              </h3>
            </div>
            <form
              id="uploadForm"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              style={styles.form}
            >
              <input
                type="file"
                name="file"
                accept=".mp4"
                required
                id="fileInput"
                onClick={handleFileInputClick}
                style={styles.fileInput}
              />
              <button
                type="submit"
                disabled={isButtonDisabled}
                style={{
                  ...styles.button,
                  background: isButtonDisabled
                    ? "black"
                    : "linear-gradient(to right, #191c51, #2092d0)",
                }}
              >
                Upload
              </button>
              <div
                id="message"
                style={{
                  ...styles.message,
                  color: isButtonDisabled ? "#191c51" : "black",
                }}
              >
                {message}
              </div>
            </form>

            {uploadProgress > 0 && uploadProgress < 100 && (
              <div style={styles.progressBarContainer}>
                <div
                  style={{
                    ...styles.progressBar,
                    width: `${uploadProgress}%`,
                  }}
                />
              </div>
            )}

            {files.length > 0 ? (
              <div style={styles.fileList}>
                {files.map((file) => (
                  <div key={file} style={styles.fileItem}>
                    <div style={{ textAlign: "webknit-left" }}>
                      <img
                        src={
                          subfolderName
                            ? `${baseURL}/thumbnails/${processedFolderName}/${subfolderName}/${file}.png`
                            : `${baseURL}/thumbnails/${processedFolderName}/${file}`
                        }
                        // src={`${baseURL}/thumbnails/${folderName}/${file}`}
                        alt={`Thumbnail`}
                        width="100px"
                        height="10%"
                        style={styles.image}
                      />
                      <span>{file}</span>
                    </div>

                    <div
                      style={{ display: "flex", flexDirection: "row", gap: 20 }}
                    >
                      <button
                        onClick={() => handleDelete(file)}
                        style={styles.actionButton1}
                      >
                        Delete
                      </button>
                      <button
                        onClick={() => handleUpdateClick(file)}
                        style={styles.actionButton}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <h4>There are no Videos in this folder!</h4>
            )}

<Modal
                   isOpen={isModalOpen}
                   onRequestClose={closeModal}
                   style={modalStyles}
                 >
              {/* <div style={styles.modalM}> */}
                <h3 style={{ fontFamily: "Montserrat" }}>
                  Select a new file to update
                </h3>
                <input
                  name="file"
                  accept=".mp4"
                  required
                  type="file"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
                <button
                  onClick={handleUpdateFile}
                  style={styles.button}
                  disabled={isUpdateButtonDisabled}
                >
                  Update File
                </button>
                <button
                  onClick={closeModal}
                  style={styles.button1}
                  disabled={isUpdateButtonDisabled}
                >
                  Close
                </button>

                {updateProgress > 0 && updateProgress < 100 && (
                  <div style={styles.progressBarContainer1}>
                    <div
                      style={{
                        ...styles.progressBar,
                        width: `${updateProgress}%`,
                      }}
                    />
                  </div>
                )}
              {/* </div> */}
              </Modal>
          </div>
        </>
      )}
    </div>
  );
};
const modalStyles = {
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.9)", // Solid white background for the screen
    zIndex: 1000, // Ensure it stays above other content
  },
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height:'40%',
    maxWidth: "400px",
    padding: "20px",
    background: 'linear-gradient(to right, rgba(28, 34, 86, 0.9), rgba(32, 146, 208, 0.9))',
    borderRadius: "10px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3)",
  },
};
const styles = {
  foldern: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    width: "100%",
    maxWidth: "85%",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    height: "90vh",

    marginTop: "1%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100vh",
    margin: 0,
    fontFamily: "Montserrat",
    background:
      "linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
  },
  form: {
    width: "30%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    // marginTop:'30px',
    marginBottom: "30px", //
    fontFamily: "Montserrat",
  },
  fileInput: {
    marginBottom: "10px",
    fontFamily: "Montserrat",
  },
  button: {
    marginTop: "20px",
    fontWeight: "bold",
    padding: "10px",
    color: "white",
    background: "#191c51",
    border: "none",
    borderRadius: "5px",
    fontFamily: "Montserrat",
  },
  buttonBack: {
    fontWeight: "bold",
    padding: "10px",
    color: "white",
    background: "#191c51",
    border: "none",
    borderRadius: "5px",
    fontFamily: "Montserrat",
  },
  button1: {
    marginTop: "20px",
    fontWeight: "bold",
    padding: "10px",
    color: "white",
    background: "linear-gradient(to right, #AA0000, #CD5C5C)",
    border: "none",
    borderRadius: "5px",
    marginLeft: "4px",
    fontFamily: "Montserrat",
  },
  message: {
    marginTop: "15px",
  },
  image: {
    verticalAlign: "-webkit-baseline-middle",
    margin: 2,
  },
  fileList: {
    // marginTop: '20px',
    width: "100%",
    //maxWidth: '80%',
    maxHeight: "55%",
    backgroundColor: "#fff",
    overflowY: "scroll",
    padding: "10px",
    borderRadius: "1px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  fileItem: {
    display: "flex",

    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
    // justifyContent:'flex-end'
  },
  actionButton: {
    marginLeft: "10px",
    padding: "5px",
    background: "#191c51",
    color: "white",
    border: "none",
    borderRadius: "3px",
  },
  actionButton1: {
    //marginLeft: '100px',
    padding: "5px",
    background: "darkred",
    color: "white",
    border: "none",
    borderRadius: "3px",
  },
  modal: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boderColor: "red",
    // padding: '90px',
    background:
      "linear-gradient(to right, rgba(28,62,110,255), rgba(32, 146, 208, 0.9))",
    // background:'linear-gradient(to right ,#c7c4bf,#908f8f)',
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    zIndex: 1000,
    boderColor: "green",
    height: "40%",
    width: "40%",
    borderRadius: 20,
    border: "solid 1px",
    color: "white",
    // justifyContent:'center',
    // alignItems:'center'
  },
  modalM: {
  
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      boderColor: "red",
      // padding: '90px',
      background:
        "linear-gradient(to right, rgba(28,62,110,255), rgba(32, 146, 208, 0.9))",
      // background:'linear-gradient(to right ,#c7c4bf,#908f8f)',
      borderRadius: "8px",
      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
      zIndex: 1000,
      boderColor: "green",
      height: "40%",
      width: "90%",
      borderRadius: 20,
      border: "solid 1px",
      color: "white",
      textAlignLast: "center",
  
   
    // justifyContent:'center',
    // alignItems:'center'
  },
  progressBarContainer: {
    marginTop: "10px",
    width: "80%",
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    height: "10px",
    marginBottom: 30,
  },
  progressBar: {
    backgroundColor: "#4caf50",
    height: "100%",
    borderRadius: "5px",
  },
  progressBarContainer1: {
    marginTop: "30px",
    width: "80%",
    backgroundColor: "#e0e0e0",
    borderRadius: "5px",
    height: "10px",
    marginBottom: 30,
    justifySelf: "center",
  },
  foldernM: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    width: "100%",
    maxWidth: "85%",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    height: "90vh",

    marginTop: "1%",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    height: "100vh",
    margin: 0,
    fontFamily: "Montserrat",
    background:
      "linear-gradient(to right, rgba(28, 34, 86, 0.6), rgba(32, 146, 208, 0.6))",
  },
  formM: {
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    // marginTop:'30px',
    marginBottom: "30px", //
    fontFamily: "Montserrat",
    textAlignLast: "center",
  },
};


export default FileUpload;
